import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import React from 'react';

import Footer from 'components/Footer';

import Header from 'components/Header';
import MobileQuickNav from 'components/MobileQuickNav';
import SubMenu from 'components/SubMenu';

import styles from './styles';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box>
      <Header />
      <MobileQuickNav />
      <SubMenu />
      <Box component="main" sx={styles.mainContent}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
